import { EventCallbackType, EventDataType, EventType } from './types';

interface IEventManager<E extends EventType = EventType> {
  addEventHandler(eventType: E, callback: EventCallbackType<E>): void;
  fireEvent(eventType: E, data: EventDataType[E]): void;
}

export class EventManager implements IEventManager {
  private eventHandlers?: Map<EventType, EventCallbackType<EventType>>;

  public addEventHandler<E extends EventType>(
    eventType: E,
    callback: EventCallbackType<E>,
  ): void {
    if (!this.eventHandlers) {
      this.eventHandlers = new Map();
    }

    this.eventHandlers.set(eventType, callback as EventCallbackType<EventType>);
  }

  public fireEvent<E extends EventType>(
    eventType: E,
    data: EventDataType[E],
  ): void {
    const eventHandler = this.eventHandlers?.get(eventType);

    if (eventHandler && data) {
      eventHandler(data);
    }
  }
}
